// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-wheel-steps {
  display: flex;
  flex-direction: column;
  background: none;
}
.change-wheel-steps.next {
  align-items: flex-end;
}
.change-wheel-steps.back {
  align-items: flex-start;
}
.change-wheel-steps span {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #7b6be4;
}
.change-wheel-steps .arrow-paginator {
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  border: 3px solid #696969;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
}
.change-wheel-steps .arrow-paginator svg {
  fill: #696969;
}
.change-wheel-steps .arrow-paginator:hover {
  background: #efefef;
  border-color: #363636;
  transform: scale(1.1);
}
.change-wheel-steps .arrow-paginator:hover svg {
  fill: #363636;
}
.change-wheel-steps .arrow-paginator:disabled {
  opacity: 0.5;
}
.change-wheel-steps .arrow-paginator:disabled:hover {
  transform: none;
  border: 3px solid #696969;
  background: white;
}
.change-wheel-steps .arrow-paginator:disabled:hover svg {
  fill: #696969;
}

.container-wheel-services-steps {
  margin: 50px auto;
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
}
.container-wheel-services-steps .ring-one {
  border: 4px solid rgba(123, 107, 228, 0.4);
  position: relative;
  border-radius: 50rem;
  width: 410px;
  height: 410px;
}
.container-wheel-services-steps .ring-two {
  border: 4px solid rgba(63, 196, 255, 0.4);
  border-radius: 50rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-wheel-services-steps .ring-two img {
  width: 100%;
}
.container-wheel-services-steps .icons-services {
  border-radius: 50%;
  box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  width: 65px;
  height: 65px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: 3.5px solid;
}
.container-wheel-services-steps .icons-services img {
  width: 40px;
  height: 40px;
}
.container-wheel-services-steps .icons-services:hover {
  transform: scale(1.1);
}
.container-wheel-services-steps .icons-services .box-info {
  width: 360px;
  height: 82px;
  position: absolute;
  display: flex;
  flex-direction: column;
}
.container-wheel-services-steps .icons-services .box-info .title-service {
  font-size: 22px;
  color: #4e5857;
}
.container-wheel-services-steps .icons-services .box-info .detail-service {
  font-size: 16px;
  font-weight: 500;
}
.container-wheel-services-steps .icons-services:nth-child(1) {
  top: -14px;
  left: 253px;
  color: #36d1ea;
  background: #36d1ea;
}
.container-wheel-services-steps .icons-services:nth-child(1) .box-info {
  top: 0;
  left: 120px;
}
.container-wheel-services-steps .icons-services:nth-child(2) {
  top: 97px;
  left: 364px;
  color: #31d7e0;
  background: #31d7e0;
}
.container-wheel-services-steps .icons-services:nth-child(2) .box-info {
  top: 0;
  left: 120px;
}
.container-wheel-services-steps .icons-services:nth-child(3) {
  top: 253px;
  left: 364px;
  color: #7b6be4;
  background: #7b6be4;
}
.container-wheel-services-steps .icons-services:nth-child(3) .box-info {
  top: 0;
  left: 120px;
}
.container-wheel-services-steps .icons-services:nth-child(4) {
  top: 364px;
  left: 253px;
  color: #6a84ec;
  background: #6a84ec;
}
.container-wheel-services-steps .icons-services:nth-child(4) .box-info {
  top: 0;
  left: 120px;
}
.container-wheel-services-steps .icons-services:nth-child(5) {
  top: 364px;
  left: 97px;
  color: #599df3;
  background: #599df3;
}
.container-wheel-services-steps .icons-services:nth-child(5) .box-info {
  top: 0;
  right: 120px;
  align-items: flex-end;
}
.container-wheel-services-steps .icons-services:nth-child(6) {
  top: 253px;
  left: -14px;
  color: #4ab4fa;
  background: #4ab4fa;
}
.container-wheel-services-steps .icons-services:nth-child(6) .box-info {
  top: 0;
  right: 120px;
  align-items: flex-end;
}
.container-wheel-services-steps .icons-services:nth-child(7) {
  top: 97px;
  left: -14px;
  color: #3fc4ff;
  background: #3fc4ff;
}
.container-wheel-services-steps .icons-services:nth-child(7) .box-info {
  top: 0;
  right: 120px;
  align-items: flex-end;
}
.container-wheel-services-steps .icons-services:nth-child(8) {
  top: -14px;
  left: 97px;
  color: #3bcaf5;
  background: #3bcaf5;
}
.container-wheel-services-steps .icons-services:nth-child(8) .box-info {
  top: 0;
  right: 120px;
  align-items: flex-end;
}

@media screen and (max-width: 1300px) {
  .container-wheel-services-steps .icons-services .box-info {
    display: none;
  }
  .container-wheel-services-steps .icons-services svg {
    width: 30sxspx;
  }
  .container-wheel-services-steps .ring-one {
    width: 300px;
    height: 300px;
  }
  .container-wheel-services-steps .icons-services {
    width: 50px;
    height: 50px;
  }
  .container-wheel-services-steps .icons-services img {
    width: 30px;
    height: 30px;
  }
  .container-wheel-services-steps .icons-services:nth-child(1) {
    top: -23px;
    left: 166px;
  }
  .container-wheel-services-steps .icons-services:nth-child(2) {
    top: 32px;
    left: 241px;
  }
  .container-wheel-services-steps .icons-services:nth-child(3) {
    top: 120px;
    left: 270px;
  }
  .container-wheel-services-steps .icons-services:nth-child(4) {
    top: 208px;
    left: 241px;
  }
  .container-wheel-services-steps .icons-services:nth-child(5) {
    top: 263px;
    left: 166px;
  }
  .container-wheel-services-steps .icons-services:nth-child(6) {
    top: 263px;
    left: 74px;
  }
  .container-wheel-services-steps .icons-services:nth-child(7) {
    top: 208px;
    left: -1px;
  }
  .container-wheel-services-steps .icons-services:nth-child(8) {
    top: 120px;
    left: -30px;
  }
  .container-wheel-services-steps .icons-services:nth-child(9) {
    top: 32px;
    left: -1px;
  }
  .container-wheel-services-steps .icons-services:nth-child(10) {
    top: -23px;
    left: 74px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/WheelSteps/wheelSteps.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AACI;EACI,qBAAA;AACR;AAAI;EACI,uBAAA;AAER;AAAI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAER;AAAI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAER;AAAQ;EACI,aAAA;AAEZ;AAAQ;EACI,mBAAA;EACA,qBAAA;EACA,qBAAA;AAEZ;AADY;EACI,aAAA;AAGhB;AADQ;EACI,YAAA;AAGZ;AAFY;EACI,eAAA;EACA,yBAAA;EACA,iBAAA;AAIhB;AAHgB;EACI,aAAA;AAKpB;;AAHA;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAMJ;AAJI;EACI,0CAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;AAMR;AAJI;EACI,yCAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAKR;AAHQ;EACI,WAAA;AAKZ;AAHI;EACI,kBAAA;EACA,6MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;AAKR;AAHQ;EACI,WAAA;EACA,YAAA;AAKZ;AAHQ;EACI,qBAAA;AAKZ;AAHQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAKZ;AAFY;EACI,eAAA;EACA,cAAA;AAIhB;AAFY;EAEQ,eAAA;EACA,gBAAA;AAGpB;AADQ;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAGZ;AAFY;EACI,MAAA;EACA,WAAA;AAIhB;AAFQ;EACI,SAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAIZ;AAHY;EACI,MAAA;EACA,WAAA;AAKhB;AAHQ;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAKZ;AAJY;EACI,MAAA;EACA,WAAA;AAMhB;AAJQ;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAMZ;AALY;EACI,MAAA;EACA,WAAA;AAOhB;AALQ;EACI,UAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;AAOZ;AANY;EACI,MAAA;EACA,YAAA;EACA,qBAAA;AAQhB;AANQ;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAQZ;AAPY;EACI,MAAA;EACA,YAAA;EACA,qBAAA;AAShB;AAPQ;EACI,SAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AASZ;AARY;EACI,MAAA;EACA,YAAA;EACA,qBAAA;AAUhB;AARQ;EACI,UAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;AAUZ;AATY;EACI,MAAA;EACA,YAAA;EACA,qBAAA;AAWhB;;AATA;EAIY;IACI,aAAA;EASd;EARU;IACI,cAAA;EAUd;EARM;IACI,YAAA;IACA,aAAA;EAUV;EARM;IACI,WAAA;IACA,YAAA;EAUV;EARU;IACI,WAAA;IACA,YAAA;EAUd;EARU;IACI,UAAA;IACA,WAAA;EAUd;EARU;IACI,SAAA;IACA,WAAA;EAUd;EARU;IACI,UAAA;IACA,WAAA;EAUd;EARU;IACI,UAAA;IACA,WAAA;EAUd;EARU;IACI,UAAA;IACA,WAAA;EAUd;EARU;IACI,UAAA;IACA,UAAA;EAUd;EARU;IACI,UAAA;IACA,UAAA;EAUd;EARU;IACI,UAAA;IACA,WAAA;EAUd;EARU;IACI,SAAA;IACA,UAAA;EAUd;EARU;IACI,UAAA;IACA,UAAA;EAUd;AACF","sourcesContent":[".change-wheel-steps\n    display: flex\n    flex-direction: column\n    background: none\n\n    &.next\n        align-items: flex-end\n    &.back\n        align-items: flex-start\n\n    & span\n        font-size: 18px\n        font-weight: 500\n        margin-bottom: 10px\n        color: #7b6be4\n\n    .arrow-paginator\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        border: 3px solid #696969\n        display: flex\n        align-items: center\n        justify-content: center\n        background: white\n        cursor: pointer\n        transition: all .3s ease\n\n        svg\n            fill: #696969\n\n        &:hover\n            background: #efefef\n            border-color: #363636\n            transform: scale(1.1)\n            svg\n                fill: #363636\n\n        &:disabled\n            opacity: .5\n            &:hover\n                transform: none\n                border: 3px solid #696969\n                background: white\n                svg\n                    fill: #696969\n\n.container-wheel-services-steps\n    margin: 50px auto\n    display: flex\n    justify-content: center\n    width: 100%\n    position: relative\n\n    & .ring-one\n        border: 4px solid #7b6be466\n        position: relative\n        border-radius: 50rem\n        width: 410px\n        height: 410px\n\n    & .ring-two\n        border: 4px solid #3fc4ff66\n        border-radius: 50rem\n        width: 100%\n        height: 100%\n\n        display: flex\n        justify-content: center\n        align-items: center\n\n        & img\n            width: 100%\n\n    & .icons-services\n        border-radius: 50%\n        box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802)\n        width: 65px\n        height: 65px\n        position: absolute\n        display: flex\n        justify-content: center\n        align-items: center\n        transition: transform .3s\n        cursor: pointer\n        user-select: none\n        border: 3.5px solid\n\n        & img\n            width: 40px\n            height: 40px\n\n        &:hover\n            transform: scale(1.1)\n\n        & .box-info\n            width: 360px\n            height: 82px\n            position: absolute\n            display: flex\n            flex-direction: column\n            //color: transparent\n\n            & .title-service\n                font-size: 22px\n                color: #4e5857\n\n            & .detail-service\n                font:\n                    size: 16px\n                    weight: 500\n\n        &:nth-child(1)//1\n            top: calc( 16px - 30px)\n            left: calc( 283px - 30px)\n            color: #36d1ea\n            background: #36d1ea\n            & .box-info\n                top: 0\n                left: 120px\n\n        &:nth-child(2)//2\n            top: calc( 127px - 30px)\n            left: calc( 394px - 30px)\n            color: #31d7e0\n            background: #31d7e0\n            & .box-info\n                top: 0\n                left: 120px\n\n        &:nth-child(3)//3\n            top: calc( 283px - 30px)\n            left: calc( 394px - 30px)\n            color: #7b6be4\n            background: #7b6be4\n            & .box-info\n                top: 0\n                left: 120px\n\n        &:nth-child(4)//4\n            top: calc( 394px - 30px)\n            left: calc( 283px - 30px)\n            color: #6a84ec\n            background: #6a84ec\n            & .box-info\n                top: 0\n                left: 120px\n\n        &:nth-child(5)//5\n            top: calc( 394px - 30px)\n            left: calc( 127px - 30px)\n            color: #599df3\n            background: #599df3\n            & .box-info\n                top: 0\n                right: 120px\n                align-items: flex-end\n\n        &:nth-child(6)//6\n            top: calc( 283px - 30px)\n            left: calc( 16px - 30px)\n            color: #4ab4fa\n            background: #4ab4fa\n            & .box-info\n                top: 0\n                right: 120px\n                align-items: flex-end\n\n        &:nth-child(7)//7\n            top: calc( 127px - 30px)\n            left: calc( 16px - 30px)\n            color: #3fc4ff\n            background: #3fc4ff\n            & .box-info\n                top: 0\n                right: 120px\n                align-items: flex-end\n\n        &:nth-child(8)//8\n            top: calc( 16px - 30px)\n            left: calc( 127px - 30px)\n            color: #3bcaf5\n            background: #3bcaf5\n            & .box-info\n                top: 0\n                right: 120px\n                align-items: flex-end\n\n@media screen and ( max-width: 1300px )\n    .container-wheel-services-steps\n\n        & .icons-services\n            & .box-info\n                display: none\n            & svg\n                width: 30sxspx\n\n        & .ring-one\n            width: 300px\n            height: 300px\n\n        & .icons-services\n            width: 50px\n            height: 50px\n\n            & img\n                width: 30px\n                height: 30px\n\n            &:nth-child(1)\n                top: calc( 7px - 30px)\n                left: calc( 196px - 30px)\n\n            &:nth-child(2)\n                top: calc( 62px - 30px)\n                left: calc( 271px - 30px)\n\n            &:nth-child(3)\n                top: calc( 150px - 30px)\n                left: calc( 300px - 30px)\n\n            &:nth-child(4)\n                top: calc( 238px - 30px)\n                left: calc( 271px - 30px)\n\n            &:nth-child(5)\n                top: calc( 293px - 30px)\n                left: calc( 196px - 30px)\n\n            &:nth-child(6)\n                top: calc( 293px - 30px)\n                left: calc( 104px - 30px)\n\n            &:nth-child(7)\n                top: calc( 238px - 30px)\n                left: calc( 29px - 30px)\n\n            &:nth-child(8)\n                top: calc( 150px - 30px)\n                left: calc( 0px - 30px)\n\n            &:nth-child(9)\n                top: calc( 62px - 30px)\n                left: calc( 29px - 30px)\n\n            &:nth-child(10)\n                top: calc( 7px - 30px)\n                left: calc( 104px - 30px)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
